module.exports = __webpack_public_path__ + "dist/img/money-balance.da028590.png";